import { Select as MantineSelect, SelectProps as MantineSelectProps } from '@mantine/core';
import styles from '../styles/Input.module.css';
import selectStyles from './Select.module.css';

import { CaretRightIcon } from 'icons/CaretRightIcon';
import { FC } from 'react';
import { joinClassNames } from 'utils/joinClassNames';

type SelectProps = MantineSelectProps;

export const Select: FC<SelectProps> = ({ classNames, rightSection, className, ...props }) => {
    const _rightSection = rightSection ?? <CaretRightIcon />;

    return (
        <MantineSelect
            className={joinClassNames(selectStyles.root, className)}
            classNames={{
                input: styles.input,
                label: styles.label,
                option: styles.option,
                description: styles.description,
                dropdown: styles.dropdown,
                ...classNames,
            }}
            rightSection={_rightSection}
            rightSectionPointerEvents="none"
            {...props}
        />
    );
};
